// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
// import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyCzG5WFAUCeNsfBtlE1EJ_YoT9n569RyG8",
	authDomain: "domestic-munshi.firebaseapp.com",
	databaseURL: "https://domestic-munshi.firebaseio.com",
	projectId: "domestic-munshi",
	storageBucket: "domestic-munshi.appspot.com",
	messagingSenderId: "734249474547",
	appId: "1:734249474547:web:3ff7278e035ce404fada86",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Auth and db references
const auth = firebase.auth();
const db = firebase.firestore();
const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope("https://www.googleapis.com/auth/contacts.readonly");
const timeStamp = firebase.firestore.FieldValue.serverTimestamp();
const arrayUnion = firebase.firestore.FieldValue.arrayUnion;
const arrayRemove = firebase.firestore.FieldValue.arrayRemove;
const deleteField = firebase.firestore.FieldValue.delete;

export default firebase;

export {
	auth,
	db,
	googleProvider,
	timeStamp,
	arrayUnion,
	arrayRemove,
	deleteField,
};
